import { useEffect } from 'react';
import { isBrowser } from 'ws-scripts/modules/environment';

/**
 * Encapsulates all PubSub subscriptions and publications for the gallery.
 * Fixes the render-body subscription bug by wrapping in useEffect with cleanup.
 */
const usePubSubListeners = ({
	onClose,
	openModal,
	totalImages,
	firstThumbnail,
	isBlackBackgroundModal
}) => {
	const pubsub = isBrowser && window?.DDC?.pubsub;

	// Publish modal open/close state changes
	useEffect(() => {
		if (pubsub) {
			pubsub.publish('ws-vehicle-gallery/modal-open', openModal);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [openModal]);

	// Publish first thumbnail for toolbar display
	useEffect(() => {
		if (pubsub && totalImages > 0 && firstThumbnail) {
			pubsub.publishDelayed(
				'ws-vehicle-toolbar/show-image',
				firstThumbnail
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [totalImages]);

	// Subscribe to external close events (moved from render body to useEffect)
	useEffect(() => {
		if (!pubsub) return undefined;

		const handleClose = (isGalleryCTABtnClicked) => {
			if (isGalleryCTABtnClicked) {
				onClose();
			}
		};

		pubsub.subscribe(
			'ws-vehicle-gallery/close-vehicle-gallery',
			handleClose
		);

		return () => {
			if (pubsub.unsubscribe) {
				pubsub.unsubscribe(
					'ws-vehicle-gallery/close-vehicle-gallery',
					handleClose
				);
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [onClose]);

	useEffect(() => {
		if (pubsub && openModal && isBlackBackgroundModal) {
			pubsub?.publish(
				'ws-vehicle-toolbar/set-black-background',
				isBlackBackgroundModal
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [openModal, isBlackBackgroundModal]);
};

export default usePubSubListeners;
